module.exports = __webpack_public_path__ + "static/media/xls.81b16fe9.svg";